/** Single source of truth for all client-side environment variables. */
export const env = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? "",
  supabaseAnonKey:
    import.meta.env.VITE_SUPABASE_ANON_KEY ??
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ??
    "",
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? "",
  sentryEnvironment:
    import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
  sentryRelease: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
  isProd: import.meta.env.PROD,
  isDev: import.meta.env.DEV,
  mode: import.meta.env.MODE,
} as const;
